export const inp = "w-full bg-background border border-border rounded-xl px-3 py-2 text-sm outline-none focus:border-primary transition-colors";
export const pill = "inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors disabled:opacity-50";
export const ROBOTS = ["index,follow", "noindex,follow", "index,nofollow", "noindex,nofollow"];
export const TYPES = [["", "All types"], ["page", "Pages"], ["book", "Books"], ["author", "Authors"], ["genre", "Genres"], ["trope", "Tropes"], ["series", "Series"]];

export function Card({ title, hint, action, children, className = "" }) {
  return (
    <section className={`rounded-2xl border border-border surface-2 p-5 ${className}`}>
      {(title || action) && <div className="flex items-start justify-between gap-3 mb-4">
        <div>{title && <h3 className="font-display font-bold text-lg">{title}</h3>}{hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}</div>{action}
      </div>}
      {children}
    </section>
  );
}

export function Field({ label, hint, children }) {
  return <label className="block"><span className="track-label text-[11px] text-muted-foreground">{label}</span><div className="mt-1">{children}</div>{hint && <span className="text-[11px] text-muted-foreground">{hint}</span>}</label>;
}

export function Score({ v }) {
  const c = v >= 85 ? "bg-emerald-500/15 text-emerald-400" : v >= 60 ? "bg-amber-500/15 text-amber-400" : "bg-destructive/15 text-destructive";
  return <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${c}`}>{v}</span>;
}

export function Stat({ label, value, tone, testid }) {
  return (
    <div className="rounded-2xl border border-border surface-2 p-4" data-testid={testid}>
      <p className="track-label text-[11px] text-muted-foreground">{label}</p>
      <p className={`text-2xl font-display font-bold mt-1 ${tone === "bad" && value ? "text-destructive" : ""}`}>{value}</p>
    </div>
  );
}

export function GooglePreview({ title, url, description }) {
  return (
    <div className="rounded-xl bg-white text-left p-4 font-sans" data-testid="seo-google-preview">
      <p className="text-[12px] text-[#202124] truncate">{url}</p>
      <p className="text-[18px] text-[#1a0dab] leading-snug truncate">{title || "Untitled"}</p>
      <p className="text-[13px] text-[#4d5156] leading-snug line-clamp-2">{description || "No description"}</p>
    </div>
  );
}
